"use strict";

require("core-js/modules/es6.typed.data-view");

require("core-js/modules/es6.typed.uint8-array");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var HeaderMarshaller_1 = require("./HeaderMarshaller");

var splitMessage_1 = require("./splitMessage");

var crc32_1 = require("@aws-crypto/crc32");
/**
 * A marshaller that can convert binary-packed event stream messages into
 * JavaScript objects and back again into their binary format.
 */


var EventStreamMarshaller =
/** @class */
function () {
  function EventStreamMarshaller(toUtf8, fromUtf8) {
    this.headerMarshaller = new HeaderMarshaller_1.HeaderMarshaller(toUtf8, fromUtf8);
  }
  /**
   * Convert a structured JavaScript object with tagged headers into a binary
   * event stream message.
   */


  EventStreamMarshaller.prototype.marshall = function (_a) {
    var rawHeaders = _a.headers,
        body = _a.body;
    var headers = this.headerMarshaller.format(rawHeaders);
    var length = headers.byteLength + body.byteLength + 16;
    var out = new Uint8Array(length);
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    var checksum = new crc32_1.Crc32(); // Format message

    view.setUint32(0, length, false);
    view.setUint32(4, headers.byteLength, false);
    view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
    out.set(headers, 12);
    out.set(body, headers.byteLength + 12); // Write trailing message checksum

    view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
    return out;
  };
  /**
   * Convert a binary event stream message into a JavaScript object with an
   * opaque, binary body and tagged, parsed headers.
   */


  EventStreamMarshaller.prototype.unmarshall = function (message) {
    var _a = splitMessage_1.splitMessage(message),
        headers = _a.headers,
        body = _a.body;

    return {
      headers: this.headerMarshaller.parse(headers),
      body: body
    };
  };
  /**
   * Convert a structured JavaScript object with tagged headers into a binary
   * event stream message header.
   */


  EventStreamMarshaller.prototype.formatHeaders = function (rawHeaders) {
    return this.headerMarshaller.format(rawHeaders);
  };

  return EventStreamMarshaller;
}();

exports.EventStreamMarshaller = EventStreamMarshaller;